import { render, staticRenderFns } from "./ContractManager.vue?vue&type=template&id=2997fcc8&"
import script from "./ContractManager.vue?vue&type=script&lang=js&"
export * from "./ContractManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QHeader,QImg,QList,QItem,QItemSection,QItemLabel,QCard,QBadge,QIcon,QCardSection,QBtn,QDialog,QCardActions,QBanner,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QHeader,QImg,QList,QItem,QItemSection,QItemLabel,QCard,QBadge,QIcon,QCardSection,QBtn,QDialog,QCardActions,QBanner})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
